import React, { useState, useEffect } from "react";
import "./CockpitLoader.scss";

const CockpitLoader: React.FC = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const duration = 2000; // 2 seconds total
        const interval = 50; // Update every 50ms
        const increment = interval / duration * 100;

        const timer = setInterval(() => {
            setProgress(prev => {
                const newProgress = prev + increment;
                if (newProgress >= 100) {
                    clearInterval(timer);
                    return 100;
                }
                return newProgress;
            });
        }, interval);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="cockpit-loader">
            <div className="loader-content">
                <div className="logo-container">
                    <img
                        src={`${import.meta.env.VITE_CDN_URL}/images/devourplay-logo2.webp`}
                        alt="DevourPlay"
                        className="logo"
                        onError={(e) => {
                            e.currentTarget.style.display = "none";
                            const fallback = e.currentTarget.parentElement?.querySelector(".logo-text");
                            if (fallback) {
                                (fallback as HTMLElement).style.display = "block";
                            }
                        }}
                    />
                    <div className="logo-text" style={{ display: "none" }}>
                        DevourPlay
                    </div>
                </div>

                <div className="progress-container">
                    <div className="progress-bar">
                        <div
                            className="progress-fill"
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CockpitLoader;